import { render, staticRenderFns } from "./dynamic.vue?vue&type=template&id=25164999&scoped=true&"
import script from "./dynamic.vue?vue&type=script&lang=ts&"
export * from "./dynamic.vue?vue&type=script&lang=ts&"
import style0 from "./dynamic.vue?vue&type=style&index=0&id=25164999&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25164999",
  null
  
)

export default component.exports